var _symbol, _symbol2, _symbol3, _filter, _symbol4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToken1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 25
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "t",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,100 100,100 50,0"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 50
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "f1",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceGraphic",
    result: "r",
    dx: 10,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "r",
    result: "rb",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "rb"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#c5e0dc",
    fillOpacity: 0.63,
    transform: "translate(153 305)  scale(2.98)  rotate(149)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#c5e0dc",
    fillOpacity: 0.84,
    transform: "translate(62 33)  scale(2.53)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.95,
    transform: "translate(92 114)  scale(1.85)  rotate(198)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.77,
    transform: "translate(471 398)  scale(4.65)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#e08e79",
    fillOpacity: 0.86,
    transform: "translate(437 317)  scale(1.22)  rotate(163)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.74,
    transform: "translate(238 204)  scale(4.46)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.82,
    transform: "translate(116 358)  scale(1.52)  rotate(349)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.87,
    transform: "translate(234 416)  scale(0.82)  rotate(25)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.75,
    transform: "translate(141 334)  scale(3.0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.85,
    transform: "translate(466 27)  scale(0.44)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.86,
    transform: "translate(379 69)  scale(0.32)  rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#e08e79",
    fillOpacity: 0.75,
    transform: "translate(218 139)  scale(2.26)  rotate(308)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.96,
    transform: "translate(272 49)  scale(2.42)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.86,
    transform: "translate(338 383)  scale(2.41)  rotate(137)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.6,
    transform: "translate(129 125)  scale(0.52)  rotate(45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.72,
    transform: "translate(118 303)  scale(3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#ece5ce",
    fillOpacity: 0.93,
    transform: "translate(357 335)  scale(2.42)  rotate(292)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.85,
    transform: "translate(479 200)  scale(0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.89,
    transform: "translate(215 45)  scale(4.78)  rotate(26)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#e08e79",
    fillOpacity: 0.8,
    transform: "translate(24 350)  scale(4.84)  rotate(292)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#c5e0dc",
    fillOpacity: 0.77,
    transform: "translate(153 318)  scale(4.88)  rotate(137)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 100,
    height: 100,
    fill: "#c5e0dc",
    fillOpacity: 0.68,
    transform: "translate(273 155)  scale(0.16)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.98,
    transform: "translate(421 472)  scale(0.51)  rotate(264)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.86,
    transform: "translate(284 479)  scale(0.74)  rotate(148)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.98,
    transform: "translate(447 352)  scale(4.41)  rotate(100)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    width: 100,
    height: 100,
    fill: "#f1d4af",
    fillOpacity: 0.84,
    transform: "translate(304 395)  scale(1.30)  rotate(53)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 100,
    height: 100,
    fill: "#c5e0dc",
    fillOpacity: 0.81,
    transform: "translate(139 259)  scale(3.89)  rotate(284)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#774f38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken1);
export default __webpack_public_path__ + "static/media/token1.3ade0f529a4748c9426a1efbb441785e.svg";
export { ForwardRef as ReactComponent };